/*!
 * JM Live Preview v1.13 add-on — Rondelle charms threaded on a chain (Mini Rondelle, Pavé Rondelle).
 * Switched on per product in metafield "Live preview: split settings" (custom.preview_split):
 *   {"rondelle": {
 *      "base":  "mini-rondelle-chain-{chain}-{metal}.jpg",      empty chain photo per chain type and metal (Content → Files)
 *      "charm": "mini-rondelle-charm-cutout-{metal}-{mon}.png", one side-on charm per metal and month (transparent PNG)
 *      "chains": {"cable": {"pts": [x0,y0,x1,y1,…]}},             centre line of each base photo's chain
 *      "chainDefault": "cable",
 *      "chainWords": {"snake": "snake|satellite", "station": "station|bead", "cable": "cable|link|drawn"},
 *      "charmH": 220,  charm height on the base photo (px)
 *      "hang": 0.2,    where the chain runs through the charm (share of its height from the top)
 *      "gap": 0.98,    centre-to-centre spacing (charm widths)
 *      "turn": 1,      how far the charms turn with the chain (0–1; below 1 they hang a little straighter)
 *      "reflect": 0.28 strength of the soft reflection under the piece (0 = none)
 *      "chains" may also hold "<chain>-silver" when the silver photo's chain sits a little differently
 *   }}
 * The customer picks one birthstone per charm (Number of Charms option); the charms are spaced evenly,
 * centred on the lowest point of the chain and turned with it, so they fan out like the real necklace.
 */
(function () {
  'use strict';
  var JM = window.JMLivePreview;
  if (!JM || !JM._tools || JM._rondelleAddon) return;
  JM._rondelleAddon = 1;
  var P = JM._tools.Preview;
  var origMedia = P.prototype.parseMediaPhotos, origRender = P.prototype.renderVariantPhotos, origHide = P.prototype.hideVariantMedia;

  function rc(self) { var s = self.cfg && self.cfg.splitCfg; return s && s.rondelle; }
  // no month photos needed: the preview is drawn from the charm cut-outs, so switch photo mode on
  P.prototype.parseMediaPhotos = function () {
    if (rc(this)) return { found: 99, byMetal: {} };
    return origMedia.call(this);
  };
  P.prototype.hideVariantMedia = function () { if (rc(this)) return; return origHide.call(this); };

  var cache = {};
  function loadImg(url) {
    if (!cache[url]) {
      cache[url] = new Promise(function (resolve, reject) {
        var i = new Image(); i.crossOrigin = 'anonymous';
        i.onload = function () { resolve(i); }; i.onerror = function () { delete cache[url]; reject(new Error('missing ' + url)); };
        i.src = url;
      });
    }
    return cache[url];
  }

  function curve(pts) {
    var n = pts.length / 2, S = [0], low = 0;
    for (var i = 1; i < n; i++) {
      S.push(S[i - 1] + Math.hypot(pts[2 * i] - pts[2 * i - 2], pts[2 * i + 1] - pts[2 * i - 1]));
      if (pts[2 * i + 1] > pts[2 * low + 1]) low = i;
    }
    function at(s) {
      s = Math.max(0, Math.min(S[n - 1], s)); var lo = 0, hi = n - 1;
      while (hi - lo > 1) { var m = (lo + hi) >> 1; if (S[m] <= s) lo = m; else hi = m; }
      var f = (s - S[lo]) / Math.max(1e-6, S[hi] - S[lo]);
      var x = pts[2 * lo] + (pts[2 * hi] - pts[2 * lo]) * f, y = pts[2 * lo + 1] + (pts[2 * hi + 1] - pts[2 * lo + 1]) * f;
      return { x: x, y: y, a: Math.atan2(pts[2 * hi + 1] - pts[2 * lo + 1], pts[2 * hi] - pts[2 * lo]) };
    }
    // lowest point, refined to the bottom of the bend
    return { at: at, low: S[low], len: S[n - 1] };
  }

  P.prototype.rondelleChain = function (R) {
    var key = R.chainDefault || Object.keys(R.chains || {})[0];
    var words = R.chainWords || { snake: 'snake|satellite', station: 'station|bead', cable: 'cable|link|drawn' };
    var v = this.variantById(this.state.variantId), opts = (this.cfg.product && this.cfg.product.options) || [];
    if (v) for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : opts[i].name;
      if (!/chain/i.test(name)) continue;
      var val = String(v.options[i] || '');
      Object.keys(words).some(function (k) { if (new RegExp(words[k], 'i').test(val) && R.chains[k]) { key = k; return true; } return false; });
    }
    return key;
  };

  P.prototype.renderVariantPhotos = function (token) {
    var R = rc(this);
    if (!R) return origRender.call(this, token);
    var self = this, metal = this.state.metal || 'gold', n = this.state.count;
    var chain = this.rondelleChain(R), C = R.chains[chain + '-' + metal] || R.chains[chain];   // a metal's photo may sit slightly differently
    function fill(p, m) { return self.cfg.filesRoot + encodeURI(p.replace(/\{metal\}/g, metal).replace(/\{chain\}/g, chain).replace(/\{mon\}/g, m || '')); }
    var jobs = [loadImg(fill(R.base) + '?width=1400')];
    for (var i = 0; i < n; i++) jobs.push(loadImg(fill(R.charm, this.months[this.state.stones[i]].key) + '?width=600'));
    return Promise.all(jobs).then(function (res) {
      if (token !== self.renderToken) return;
      var base = res[0], charms = res.slice(1);
      var W = base.naturalWidth, H = base.naturalHeight, k0 = W / (C.w || W);   // base may be served smaller
      var cv = self.canvas;
      if (!cv) { cv = self.canvas = document.createElement('canvas'); cv.className = 'jmlp__canvas'; cv.setAttribute('role', 'img'); self.stage.insertBefore(cv, self.layersEl); }
      cv.width = W; cv.height = H;
      cv.setAttribute('aria-label', self.recipe().stones.map(function (s) { return s.label; }).join(', '));
      var x = cv.getContext('2d');
      x.drawImage(base, 0, 0);
      var pts = C.pts.map(function (v) { return v * k0; }), cu = curve(pts);
      var ch = (R.charmH || 220) * k0, hang = R.hang == null ? 0.2 : R.hang;
      // every charm drawn at the same width (the renders differ a little in height)
      var cw = charms[0].naturalWidth * ch / charms[0].naturalHeight, step = cw * (R.gap || 0.98);
      var mid = cu.low + (R.shift || 0) * k0;
      var pos = charms.map(function (img, i) {
        var k = i - (n - 1) / 2, q = cu.at(mid + k * step);
        return { img: img, k: k, x: q.x, y: q.y, a: q.a * (R.turn == null ? 1 : R.turn) };
      });
      // charms on their own layer (for the reflection), outer ones first so the middle sits in front
      var L = document.createElement('canvas'); L.width = W; L.height = H; var lx = L.getContext('2d');
      var bx0 = 1e9, bx1 = -1e9, by0 = 1e9, by1 = -1e9;
      pos.slice().sort(function (a, b) { return Math.abs(b.k) - Math.abs(a.k); }).forEach(function (q) {
        var w = cw, h = q.img.naturalHeight * cw / q.img.naturalWidth;
        lx.save(); lx.translate(q.x, q.y); lx.rotate(q.a); lx.drawImage(q.img, -w / 2, -hang * h, w, h); lx.restore();
        [[-w / 2, -hang * h], [w / 2, -hang * h], [-w / 2, (1 - hang) * h], [w / 2, (1 - hang) * h]].forEach(function (c) {
          var px = q.x + c[0] * Math.cos(q.a) - c[1] * Math.sin(q.a), py = q.y + c[0] * Math.sin(q.a) + c[1] * Math.cos(q.a);
          bx0 = Math.min(bx0, px); bx1 = Math.max(bx1, px); by0 = Math.min(by0, py); by1 = Math.max(by1, py);
        });
      });
      x.drawImage(L, 0, 0);
      // soft reflection of the whole piece (chain end + charms) on the surface just under the charms,
      // as in the main product photos (the base photos come without one)
      var rs = R.reflect == null ? 0.28 : R.reflect;
      if (rs > 0) {
        var plane = by1 + ch * 0.03, depth = ch * 0.8;
        var Rf = document.createElement('canvas'); Rf.width = W; Rf.height = H; var rx = Rf.getContext('2d');
        rx.save(); rx.translate(0, 2 * plane); rx.scale(1, -1); rx.drawImage(cv, 0, 0); rx.restore();
        rx.globalCompositeOperation = 'destination-in';
        var g = rx.createLinearGradient(0, plane, 0, plane + depth);
        g.addColorStop(0, 'rgba(0,0,0,' + rs + ')'); g.addColorStop(1, 'rgba(0,0,0,0)');
        rx.fillStyle = g; rx.fillRect(0, 0, W, H);
        rx.globalCompositeOperation = 'destination-out'; rx.fillRect(0, 0, W, plane); rx.fillRect(0, plane + depth, W, H);
        x.drawImage(Rf, 0, 0);
      }
      // square around the charms for the floating mini preview and the gallery thumbnail
      var fs = Math.min(W, H, Math.max(bx1 - bx0, by1 - by0) * 1.5 + ch * 0.5), fcx = (bx0 + bx1) / 2, fcy = (by0 + by1) / 2;
      self.focus = { x: Math.max(0, Math.min(W - fs, fcx - fs / 2)), y: Math.max(0, Math.min(H - fs, fcy - fs / 2)), s: fs };
      self.paintCopies();
      self.stage.classList.add('jmlp__stage--canvas');
    });
  };

  // The core builds the previews as soon as it runs, which can be before this add-on has loaded:
  // switch any Rondelle preview it already built over to the charm drawing.
  Object.keys(JM).forEach(function (k) {
    var p = JM[k];
    if (!p || !(p instanceof P) || !rc(p) || p.photoMode || p.cfg.mode !== 'variant') return;
    p.mediaPhotos = { found: 99, byMetal: {} };
    p.photoMode = true;
    if (!p.mini) p.buildMini('jmlp-moved-' + p.id);
    p.syncFromVariant(true);
  });
})();
